
export default function ServicesSection() {
  const services = [
    {
      title: 'Video Creation & Distribution (3xMatrix)',
      description: 'Professional video content creation and strategic distribution across multiple platforms to maximize reach and engagement.',
      icon: 'ri-video-line',
      image: 'https://public.readdy.ai/ai/img_res/182eb54145b79a94d064a6b0753467f9.jpg'
    },
    {
      title: 'Search Engine Optimization (SEO)',
      description: 'Data-driven SEO strategies to improve your organic search rankings and drive qualified traffic to your website.',
      icon: 'ri-search-line',
      image: 'https://readdy.ai/api/search-image?query=SEO%20analytics%20dashboard%20on%20computer%20screen%2C%20search%20engine%20optimization%20charts%20and%20graphs%2C%20digital%20marketing%20workspace%2C%20keyword%20research%20tools%2C%20website%20ranking%20analytics%2C%20modern%20office%20environment%20with%20SEO%20data%20visualization&width=400&height=300&seq=seo-service&orientation=landscape'
    },
    {
      title: 'Media Pitch & Public Relations',
      description: 'Strategic media outreach and PR campaigns to secure coverage in top-tier publications and build brand authority.',
      icon: 'ri-newspaper-line',
      image: 'https://readdy.ai/api/search-image?query=Public%20relations%20professional%20working%20on%20media%20campaigns%2C%20press%20releases%20and%20news%20articles%20on%20desk%2C%20modern%20PR%20office%20environment%2C%20media%20outreach%20materials%2C%20professional%20journalism%20workspace%2C%20contemporary%20business%20setting&width=400&height=300&seq=pr-service&orientation=landscape'
    },
    {
      title: 'Influencer Marketing',
      description: 'Connect with relevant influencers and content creators to amplify your brand message and reach new audiences.',
      icon: 'ri-user-star-line',
      image: 'https://readdy.ai/api/search-image?query=Influencer%20marketing%20campaign%20planning%2C%20social%20media%20content%20creation%20workspace%2C%20influencer%20collaboration%20materials%2C%20modern%20digital%20marketing%20office%2C%20content%20creator%20partnership%20planning%2C%20contemporary%20marketing%20environment&width=400&height=300&seq=influencer-marketing&orientation=landscape'
    },
    {
      title: 'Newsletter Sponsorships',
      description: 'Strategic newsletter placements to reach highly engaged audiences and drive targeted traffic to your business.',
      icon: 'ri-mail-line',
      image: 'https://readdy.ai/api/search-image?query=Email%20marketing%20campaign%20design%20on%20computer%20screen%2C%20newsletter%20templates%20and%20analytics%2C%20digital%20marketing%20workspace%2C%20email%20automation%20tools%2C%20modern%20office%20environment%20with%20marketing%20materials%2C%20professional%20email%20marketing%20setup&width=400&height=300&seq=newsletter-sponsorship&orientation=landscape'
    },
    {
      title: 'Paid Ads',
      description: 'Performance-driven paid advertising campaigns across Google, Facebook, LinkedIn, and other platforms for maximum ROI.',
      icon: 'ri-advertisement-line',
      image: 'https://readdy.ai/api/search-image?query=Digital%20advertising%20dashboard%20with%20campaign%20analytics%2C%20paid%20ads%20performance%20metrics%20on%20screens%2C%20modern%20marketing%20office%2C%20PPC%20campaign%20management%20workspace%2C%20advertising%20ROI%20charts%20and%20graphs%2C%20contemporary%20digital%20marketing%20environment&width=400&height=300&seq=paid-ads&orientation=landscape'
    },
    {
      title: 'Online Communities',
      description: 'Build and nurture engaged online communities around your brand to foster customer loyalty and advocacy.',
      icon: 'ri-team-line',
      image: 'https://readdy.ai/api/search-image?query=Online%20community%20management%20workspace%2C%20social%20media%20engagement%20tools%2C%20community%20building%20materials%2C%20modern%20digital%20marketing%20office%2C%20social%20platform%20management%20screens%2C%20contemporary%20community%20marketing%20environment&width=400&height=300&seq=online-communities&orientation=landscape'
    },
    {
      title: 'Full-Service Campaigns',
      description: 'Comprehensive marketing campaigns that integrate multiple channels for cohesive brand messaging and maximum impact.',
      icon: 'ri-rocket-line',
      image: 'https://readdy.ai/api/search-image?query=Comprehensive%20marketing%20campaign%20planning%20workspace%2C%20integrated%20marketing%20strategy%20materials%2C%20multi-channel%20campaign%20dashboard%2C%20modern%20marketing%20agency%20office%2C%20strategic%20planning%20environment%2C%20contemporary%20business%20workspace&width=400&height=300&seq=full-service-campaigns&orientation=landscape'
    }
  ];

  return (
    <section id="services" className="py-20 bg-gradient-to-br from-gray-50 via-amber-50/20 to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-600 via-yellow-500 to-amber-700">Services</span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-amber-500 via-yellow-400 to-amber-600 mx-auto mb-8 shadow-sm"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive marketing solutions designed to accelerate your business <span className="text-amber-700 font-semibold">growth</span>
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div key={index} className="group bg-gradient-to-br from-white via-amber-50/30 to-white rounded-xl p-6 hover:shadow-xl transition-all duration-300 hover:transform hover:scale-105 border border-amber-100/30 hover:border-amber-200/50">
              <div className="mb-6">
                <div className="relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-amber-100/20 to-yellow-100/20 rounded-lg transform rotate-1"></div>
                  <img 
                    src={service.image}
                    alt={service.title}
                    className="relative w-full h-48 object-cover object-top rounded-lg mb-4 border border-amber-100/5"
                  />
                </div>
                <div className="relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-amber-200/30 to-yellow-200/30 rounded-lg transform scale-110"></div>
                  <div className="relative w-12 h-12 bg-gradient-to-r from-amber-500 to-amber-600 rounded-lg flex items-center justify-center shadow-lg">
                    <i className={`${service.icon} text-white text-xl`}></i>
                  </div>
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-amber-800 transition-colors">
                {service.title.includes('(3xMatrix)') ? (
                  <>
                    Video Creation & Distribution{' '}
                    <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-600 to-yellow-600 font-bold">(3xMatrix)</span>
                  </>
                ) : service.title.includes('SEO') ? (
                  <>
                    Search Engine Optimization{' '}
                    <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-600 to-yellow-600 font-bold">(SEO)</span>
                  </>
                ) : (
                  service.title
                )}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="relative bg-gradient-to-br from-white via-amber-50/40 to-white rounded-2xl p-8 border border-amber-100/50 shadow-lg">
            <div className="absolute inset-0 bg-gradient-to-r from-amber-100/10 to-yellow-100/10 rounded-2xl transform -rotate-1"></div>
            <div className="relative">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Ready to Elevate Your <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-600 to-yellow-600">Marketing?</span>
              </h3>
              <p className="text-gray-700 mb-6 max-w-2xl mx-auto">
                Let's discuss how our <span className="text-amber-700 font-semibold">premium services</span> can transform your business growth strategy.
              </p>
              <button 
                onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                className="bg-gradient-to-r from-amber-500 to-amber-600 text-white px-8 py-3 rounded-lg font-semibold hover:from-amber-600 hover:to-amber-700 transition-all duration-300 hover:transform hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg"
              >
                <i className="ri-calendar-line mr-2"></i>
                Schedule Your <span className="font-bold">Free</span> Consultation
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
